import { PRODUCT_TYPES } from '../enums/product-types';
import { PAGE_TYPES } from '../enums/page-types';
import PaymentOptionsEnum from '../enums/payment-options';
import { isBelowMinimumChargeAmount } from '../services/currency';
import checkIsFreeCheckout from './checkIsFreeCheckout';
import checkIsFreeEvent from './checkIsFreeEvent';
import getSelectedTicketTypes from './getSelectedTicketTypes';

/**
 * Check if payment methods should be shown
 * @param {Object} options
 * @param {string} options.paymentOption - Payment option
 * @param {number} options.amount - Total amount of the cart
 * @param {Object} options.checkout - Checkout object
 * @param {Object} options.product - Product object
 * @param {Object} options.form - Form object
 * @param {boolean} options.isUpsell - Is upsell
 * @param {boolean} options.isUpsellRetry - Is upsell retry
 * @param {boolean} options.coupon - coupon object
 * @returns {boolean} - Should show payment methods
 */
export default function checkShouldShowPaymentMethods({
  paymentOption,
  amount,
  checkout,
  product,
  form,
  isUpsell,
  isUpsellRetry,
  coupon,
}) {
  if (paymentOption.type === PaymentOptionsEnum.MANUAL) {
    return false;
  }

  if (isUpsell) {
    if (isUpsellRetry) {
      return true;
    } else {
      return false;
    }
  }

  const isForm = checkout.type === PAGE_TYPES.FORM;

  if (isForm) {
    return false;
  }

  const isEvent = checkout.type === PAGE_TYPES.EVENT;

  if (isEvent) {
    const isFreeEvent = checkIsFreeEvent({
      pageTicketGroups: checkout.ticketGroups,
    });

    const selectedTickets = getSelectedTicketTypes(checkout.ticketGroups, form.ticketGroups);
    const hasSelectedTickets = selectedTickets.length > 0;

    // Free event with no cost - no payment needed
    if (isFreeEvent && amount === 0) {
      return false;
    }

    // No tickets selected but event has paid options - show payment methods until a selection is made
    if (!hasSelectedTickets) {
      return true;
    }

    if (amount > 0) {
      // show payment methods if there's a cost (e.g. additional fees)
      return true;
    } else {
      // don't show payment methodsif there's no cost, only selected free tickets
      return false;
    }
  }

  if (checkout.type === PAGE_TYPES.CHECKOUT && product.type === PRODUCT_TYPES.ONE_TIME) {
    const isFreeCheckout = checkIsFreeCheckout({
      amount: amount,
      productType: product.type,
      productVariants: product.variants,
      formVariants: form.variants,
    });

    if (isFreeCheckout) {
      return false;
    }

    if (amount === 0 && coupon) {
      return false;
    }
  } else if (checkout.type === PAGE_TYPES.CHECKOUT && product.type === PRODUCT_TYPES.SUBSCRIPTION) {
    return true;
  }

  return true;
}
